import React, {
  Dispatch,
  SetStateAction,
  useState,
  // useCallback
} from 'react';
import debug from 'debug';
// const d = debug('uiContext');

interface IPageContextInterface {
  debugMode: boolean;
  setDebugMode: (val: boolean) => void; //Dispatch<SetStateAction<boolean>>;
  cdnDisabled: boolean;
  setCDNDisabled: (val: boolean) => void;
  stickyMenu: boolean;
  setStickyMenu: Dispatch<SetStateAction<boolean>>;
  transparentMenu: boolean;
  setTransparentMenu: Dispatch<SetStateAction<boolean>>;
  showExploreDrawer: boolean;
  setShowExploreDrawer: Dispatch<SetStateAction<boolean>>;
  showPhatHeader: boolean;
  setShowPhatHeader: Dispatch<SetStateAction<boolean>>;
}

export const uiContext = React.createContext<IPageContextInterface>({
  debugMode: false,
  setDebugMode: () => false,
  cdnDisabled: false,
  setCDNDisabled: (val: boolean) => {},
  stickyMenu: true,
  setStickyMenu: () => false,
  transparentMenu: false,
  setTransparentMenu: () => false,
  showExploreDrawer: false,
  setShowExploreDrawer: () => false,
  showPhatHeader: false,
  setShowPhatHeader: () => false,
});

const { Provider } = uiContext;

const UIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [stickyMenu, setStickyMenu] = useState<boolean>(true);
  const [transparentMenu, setTransparentMenu] = useState<boolean>(false);
  const [showExploreDrawer, setShowExploreDrawer] = useState<boolean>(false);
  const [showPhatHeader, setShowPhatHeader] = useState<boolean>(false);
  const [debugMode, _setDebugMode] = useState<boolean>(localStorage.getItem('DEBUG_MODE') === 'true');
  const [cdnDisabled, _setCDNDisabled] = useState<boolean>(process.env['REACT_APP_CDN_API'] === 'true' && localStorage.getItem('CDN_DISABLED') !== 'true');
  const setDebugMode = (val: boolean) => {
    if (val) {
      localStorage.setItem('DEBUG_MODE', 'true');
      debug.enable('*,-kl_forms*');
    } else {
      localStorage.removeItem('DEBUG_MODE');
      debug.disable();
    }
    _setDebugMode(val);
  };
  const setCDNDisabled = (val: boolean) => {
    if (val) {
      localStorage.removeItem('CDN_DISABLED');
    } else {
      localStorage.setItem('CDN_DISABLED', 'true');
    }
    _setCDNDisabled(val);
  };

  return (
    <Provider
      value={{
        debugMode,
        setDebugMode,
        stickyMenu,
        setStickyMenu,
        transparentMenu,
        setTransparentMenu,
        cdnDisabled,
        setCDNDisabled,
        showExploreDrawer,
        setShowExploreDrawer,
        showPhatHeader,
        setShowPhatHeader,
      }}
    >
      {children}
    </Provider>
  );
};

export default UIProvider;
